// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Contas_AtualizaContaInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for PUT /contas/atualiza_conta/{conta_id}
 *
 * Updates an existing financial account.
 */
import { registerContract } from './validate'

export interface Contas_AtualizaContaInput {
conta_nome?: string
conta_franquia_id?: number
conta_tipo?: string
conta_status?: number
conta_permite_gerar_link_pagto?: number
conta_provedor?: string
conta_id_externo?: string
}

registerContract('Contas_AtualizaContaInput', {
  conta_nome:                     { type: 'string',  required: false },
  conta_franquia_id:              { type: 'number',  required: false },
  conta_tipo:                     { type: 'string',  required: false },
  conta_status:                   { type: 'number',  required: false },
  conta_permite_gerar_link_pagto: { type: 'number',  required: false },
  conta_provedor:                 { type: 'string',  required: false },
  conta_id_externo:               { type: 'string',  required: false },
})
